import { render, staticRenderFns } from "./Wap_JLCT82_Produce.vue?vue&type=template&id=2b7bd946&scoped=true&"
import script from "./Wap_JLCT82_Produce.vue?vue&type=script&lang=js&"
export * from "./Wap_JLCT82_Produce.vue?vue&type=script&lang=js&"
import style0 from "./Wap_JLCT82_Produce.vue?vue&type=style&index=0&id=2b7bd946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7bd946",
  null
  
)

export default component.exports